  export const ListaMenu = [
    {
      menu: "Profissionais",
      descricao: "Gerencie os profissionais",
      link: "/admin/profissionais",
      icone: "user",
      master: false
    }, {
      menu: "Estabelecimentos",
      descricao: "Gerencie os estabelecimentos",
      link: "/admin/estabelecimentos",
      icone: "location",
      master: false
    }, {
      menu: "Usuários",
      descricao: "Gerencie os usuários",
      link: "/admin/usuarios",
      icone: "users",
      master: true
    }, {
      menu: "Push",
      descricao: "Gerencie as notificações",
      link: "/admin/push",
      icone: "bell",
      master: false
    }, {
      menu: "Vagas",
      descricao: "Gerencie as vagas",
      link: "/admin/vagas",
      icone: "list",
      master: false
    }
  ];